/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

import { Configuration, OpenAIApi } from "openai";

/* global global, Office, self, window */

Office.onReady(() => {
  Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, itemChanged);

  UpdateTaskPaneUI(Office.context.mailbox.item);
});

function itemChanged() {
  UpdateTaskPaneUI(Office.context.mailbox.item);
}

function UpdateTaskPaneUI(item) {
  // eslint-disable-next-line no-undef
  if (item != null) console.log(item.subject);
}

/**
 * Shows a notification when the add-in command is executed.
 * @param event
 */

function action(event: Office.AddinCommands.Event) {
  getSelectedText().then(function (selectedText) {
    Office.context.mailbox.item.setSelectedDataAsync(selectedText, { coercionType: Office.CoercionType.Text });
    event.completed();
  });
}

function getGlobal() {
  return typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
    ? window
    : typeof global !== "undefined"
    ? global
    : undefined;
}

const g = getGlobal() as any;

// The add-in command functions need to be available in global scope
g.action = action;

function getSelectedText(): Promise<any> {
  return new Office.Promise(function (resolve, reject) {
    try {
      Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, async function (asyncResult) {
        let tone = "casual";
        const configuration = new Configuration({
          apiKey: "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",
        });
        const openai = new OpenAIApi(configuration);
        const response = await openai.createCompletion({
          model: "text-davinci-003",
          prompt: "Turn the following text into a " + tone + " reply mail by doctor: " + asyncResult.value,
          temperature: 0.7,
          max_tokens: 300,
        });

        resolve(response.data.choices[0].text);
      });
    } catch (error) {
      reject(error);
    }
  });
}
